import React, { useEffect, useState, useRef } from "react";
import { TextField, Grid, MenuItem, Typography,Select,InputLabel,
   FormControl,Checkbox,ListItemText,OutlinedInput, Autocomplete} from "@mui/material";
import MasterViewController from "../../../redux/actions/masterApiActions";
import { useDispatch, useSelector } from "react-redux";
import EmployeeProfileVeiwController from "../../../redux/actions/EmployeeProfileApiAction";
import EmployerViewController from "../../../redux/actions/EmployerApiAction";
const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday",
  "Thursday", "Friday", "Saturday", "Sunday"
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  disableScrollLock: true, // Prevent modal scroll lock issue
};

const employeeStatusOptions = [
  { label: "Active", value: "active" },
  { label: "On Leave", value: "on_leave" },
  { label: "Inactive", value: "inactive" },
  { label: "Resigned", value: "resigned" },
];

const employmentTypeOptions = [
  { label: "Full-Time", value: "FT" },
  { label: "Part-Time", value: "PT" },
  { label: "Contract", value: "CT" },
  { label: "Probation", value: "PR" },
  { label: "Work-From-Home", value: "WFH" },
];


const EmploymentDetailsTab = ({ formik }) => {
  const { values, errors, touched, handleChange, handleBlur,setFieldValue } = formik;
  const dispatch = useDispatch();
  const { getEmployees } = EmployeeProfileVeiwController();
  const { getAllEmployeeEmployer } = EmployerViewController();
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const { employers } = useSelector((state) => state.employer);
  const employees = employee_data?.employees || [];
  const { getDepartments, getDesignations } = MasterViewController();
  const { departments,designations } = useSelector((state) => state.master);

  useEffect(() => {
      dispatch(getAllEmployeeEmployer());
      dispatch(getDepartments());
      dispatch(getDesignations());
    }, []);

  const reportingManagerOptions = employers.map((emp) => ({
  label: emp.full_name || `${emp.first_name} ${emp.last_name}`,
  value: emp.id,
}));

  
  return (
    <Grid container spacing={2} mt={1}>
      {/* Employment Details fields */}
      <Grid item xs={12} sm={6}>
  <Autocomplete
    fullWidth
    options={departments || []}
    getOptionLabel={(option) => option.name || ""}
    value={
      departments.find((opt) => opt.id === values.department) || null
    }
    onChange={(event, newValue) => {
      setFieldValue("department", newValue ? newValue.id : "");
    }}
    onBlur={handleBlur}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Department"
        name="department"
        error={touched.department && Boolean(errors.department)}
        helperText={touched.department && errors.department}
      />
    )}
    ListboxProps={{
      style: { maxHeight: 4 * 48, overflowY: "auto" },
    }}
  />
</Grid>

      <Grid item xs={12} sm={6}>
  <Autocomplete
    fullWidth
    options={designations || []}
    getOptionLabel={(option) => option.name || ""}
    value={
      designations.find((opt) => opt.id === values.designation) || null
    }
    onChange={(event, newValue) => {
      setFieldValue("designation", newValue ? newValue.id : "");
    }}
    onBlur={handleBlur}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Designation"
        name="designation"
        error={touched.designation && Boolean(errors.designation)}
        helperText={touched.designation && errors.designation}
      />
    )}
    ListboxProps={{
      style: { maxHeight: 4 * 48, overflowY: "auto" },
    }}
  />
</Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="date"
          label="Date of Joining"
          name="joining_date"
          value={values.joining_date}
          onChange={handleChange}
          onBlur={handleBlur}
          InputLabelProps={{ shrink: true }}
          error={touched.joining_date && Boolean(errors.joining_date)}
          helperText={touched.joining_date && errors.joining_date}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
      <Autocomplete
        fullWidth
        options={employmentTypeOptions}
        getOptionLabel={(option) => option.label}
        value={
          employmentTypeOptions.find(
            (opt) => opt.value === values.employment_type
          ) || null
        }
        onChange={(event, newValue) => {
          setFieldValue("employment_type", newValue ? newValue.value : "");
        }}
        onBlur={handleBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Employment Type"
            name="employment_type"
            error={touched.employment_type && Boolean(errors.employment_type)}
            helperText={touched.employment_type && errors.employment_type}

          />
        )}
      />
    </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Work Location"
          name="work_location"
          value={values.work_location}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.work_location && Boolean(errors.work_location)}
          helperText={touched.work_location && errors.work_location}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
      <Autocomplete
        fullWidth
        options={reportingManagerOptions}
        getOptionLabel={(option) => option.label}
        value={
          reportingManagerOptions.find(
            (opt) => opt.value === values.reporting_manager
          ) || null
        }
        onChange={(event, newValue) => {
          setFieldValue("reporting_manager", newValue ? newValue.value : "");
        }}
        onBlur={handleBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Reporting Manager"
            name="reporting_manager"
            error={touched.reporting_manager && Boolean(errors.reporting_manager)}
            helperText={touched.reporting_manager && errors.reporting_manager}
          />
        )}
        ListboxProps={{
          style: {
            maxHeight: 4 * 48, // ~4 items, 48px each
            overflowY: "auto",
          },
        }}
      />
    </Grid>


      <Grid item xs={12} sm={6}>
      <Autocomplete
        fullWidth
        options={employeeStatusOptions}
        getOptionLabel={(option) => option.label}
        value={
          employeeStatusOptions.find(
            (opt) => opt.value === values.employee_status
          ) || null
        }
        onChange={(event, newValue) => {
          setFieldValue("employee_status", newValue ? newValue.value : "");
        }}
        onBlur={handleBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Employee Status"
            name="employee_status"
            error={touched.employee_status && Boolean(errors.employee_status)}
            helperText={touched.employee_status && errors.employee_status}
          />
        )}
      />
    </Grid>

      {/* Divider / space */}
      <Grid item xs={12} sx={{ mt: 3 }}>
        <Typography variant="h6" component="h3" gutterBottom>
          Job Role & Work Schedule
        </Typography>
      </Grid>

      {/* Job Role & Work Schedule fields */}
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Job Description"
          name="job_description"
          value={values.job_description}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.job_description && Boolean(errors.job_description)}
          helperText={touched.job_description&& errors.job_description}
          multiline
          rows={3}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Shift Timing"
          name="shift_timing"
          value={values.shift_timing}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.shift_timing && Boolean(errors.shift_timing)}
          helperText={touched.shift_timing && errors.shift_timing}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={touched.weekly_off && Boolean(errors.weekly_off)}>
          <InputLabel>Weekly Off</InputLabel>
          <Select
            multiple
            name="weekly_off"
            value={values.weekly_off || []}
            onChange={(event) => {
              setFieldValue("weekly_off", event.target.value);
            }}
            onBlur={handleBlur}
            input={<OutlinedInput label="Weekly Off" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {daysOfWeek.map((day) => (
              <MenuItem key={day} value={day}>
                <Checkbox checked={values.weekly_off?.includes(day)} />
                <ListItemText primary={day} />
              </MenuItem>
            ))}
          </Select>
          {touched.weekly_off && errors.weekly_off && (
            <Typography color="error" variant="caption">
              {errors.weekly_off}
            </Typography>
          )}
        </FormControl>
      </Grid>


      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Working Hours"
          name="working_hours"
          value={values.working_hours}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.working_hours && Boolean(errors.working_hours)}
          helperText={touched.working_hours && errors.working_hours}
        />
      </Grid>
    </Grid>
  );
};

export default EmploymentDetailsTab;
